import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { MyIcon, IMG_DEFAULT } from "../../common/baseConfig";
import { List, Popconfirm, Button, message, Modal, Input } from "antd";
import NoneData from "../common/NoneData";
import moment from "moment";
const { TextArea } = Input;
export class MyOrderPane extends Component {
  state = {
    visible: false,
    SuccessVisible: false,
    refundOrder: null,//退款的订单信息
    refundItem: null,//退款的商品信息
    refundTxt: "",//退款原因
    curPage: 1,
    orderDetailOpened: false,
    orderDetailItem: null
  }
  static propTypes = {
    center: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentDidMount() {
    this.onLoadMyOrder();
  }
  onLoadMyOrder() {
    this.props.actions.fetchGetMyOrder({
      PageSize: 5,
      PageIndex: this.state.curPage,
      PageStatus: 1,
      PayStatus: this.props.PayStatus,
    })
  }
  //申请退款
  _refund(item, items) {
    this.setState({
      refundOrder: item,
      refundItem: items,
      visible: true,
    })
  }
  //提交退款
  refundSubmit() {
    const { refundItem, refundOrder, refundTxt } = this.state;
    let id = {}, params = {};
    refundItem.BusType === 0 ?
      id = { Course_ID: refundItem.Course_ID }
      :
      refundItem.BusType === 1 ?
        id = { Course_ID: refundItem.Package_ID }
        :
        id = { Course_ID: refundItem.Stage_ID }
    params = {
      ...id,
      OrderId: refundOrder.OrderId,
      Price: refundItem.PreferentialPrice,
      BusType: refundItem.BusType,
      RefundReason: refundTxt,
    }
    this.props.actions.fetchRefund(params).then(res => {
      if (res.SuccessResponse) {
        this.setState({
          visible: false,
          SuccessVisible: true,
        }, () => {
          this.onLoadMyOrder();
        })
      }
    })
  }
  //删除订单
  deleteOrder(ID) {
    this.props.actions.fetchDeleteOrder({ Ids: ID }).then(res => {
      if (res.SuccessResponse) {
        message.success("删除订单成功");
        this.onLoadMyOrder();
      }
    });
  }
  //取消订单
  cancelOrder(ID) {
    this.props.actions.fetchCancelOrder({
      ID,
    }).then(res => {
      if (res.SuccessResponse) {
        message.success("取消订单成功");
        this.onLoadMyOrder();
      }
    })
  }
  RefundStatusHandle(status) {
    switch (status) {
      case 0:
        return <span className="default">退款中</span>

      case 1:
        return <span className="success">审核通过</span>

      case 2:
        return <span className="fail">审核拒绝</span>

      case 3:
        return <span className="success">退款成功</span>

      case 4:
        return <span className="default">已拒绝</span>

      case 5:
        return <span className="fail">退款失败</span>
      default:
        break;
    }
  }
  status(item, ele) {
    if (item.IsDelete === 1) {
      return "已取消";
    } else if (item.PayStatus === 1) {
      if (ele.IsRefund === 1) {
        if (ele.RefundStatus === -1) {
          if (moment(new Date()).diff(moment(new Date(item.PayTime)), 'minute') > 30) {
            return ''
          } else {
            return <span style={{ cursor: "pointer" }} onClick={() => this._refund(item, ele)}>申请退款</span>;
          }
        } else {
          return this.RefundStatusHandle(ele.RefundStatus);
        }
      }
      return "已开通";
    } else {
      return "等待付款";
    }
  }
  IsCollapse(item, ele, i) {
    let data = [...item.OrderDetailList,
    ...item.OrderDetailListPack,
    ...item.OrderDetailListStage];

    let result = data.some((it => {
      return item.PayStatus === 1 && it.IsRefund === 1;
    }))
    if (!result) {
      if (i === 0) {
        return (
          <td className="thirdTd" rowSpan={data.length}>
            {this.status(item, ele)}
          </td>
        )
      } else {
        return null;
      }
    } else {
      return (
        <td className="thirdTd">
          {this.status(item, ele)}
        </td>
      )
    }
  }
  IsCollapseBtn(item, ele, i) {
    let data = [...item.OrderDetailList, ...item.OrderDetailListPack, ...item.OrderDetailListStage];

    if (item.IsDelete === 1) {
      if (i === 0) {
        return (
          <td className="fourTd" rowSpan={data.length}>
            <Popconfirm placement="top" title={"确认删除订单吗？"} onConfirm={() => this.deleteOrder(item.ID)} okText="确认" cancelText="取消">
              <p>删除订单</p>
            </Popconfirm>
          </td>
        )
      } else {
        return null;
      }
    } else if (item.PayStatus === 1) {
      return (
        <td className="fourTd">
          <Button type="theme" disabled={ele.RefundStatus === 3} onClick={() => {
            if (ele.Package_ID !== 0) {
              this.props.history.push(`/coursepack/detail/${ele.Package_ID}`);
            } else {
              this.props.history.push(`/course/detail/${ele.Course_ID}`);
            }
          }}>进入学习</Button>
        </td>
      )
    } else {
      if (i === 0) {
        return (
          <td className="fourTd" rowSpan={data.length}>
            <Button type="theme" onClick={() => {
              if (moment(new Date()).diff(moment(new Date(item.PayTime)), 'minute') > 30) {
                message.warn('该订单已过期，请重新下单');
                this.props.actions.fetchUpdateOrderState({ OrderNo: item.OrderNo }).then(res => {
                  if (res.SuccessResponse) {
                    this.onLoadMyOrder();
                  }
                });
                return;
              }
              this.props.history.push(`/paytype/${item.OrderId}`)
            }}>立即支付</Button>
            <Popconfirm placement="top" title="确定取消订单吗?" onConfirm={() => this.cancelOrder(item.ID)} okText="确定" cancelText="取消">
              <p>取消订单</p>
            </Popconfirm>
          </td>
        )
      } else {
        return null;
      }
    }
  }

  //打开订单详情弹出框
  onOrderDetail(item) {
    this.setState({ orderDetailOpened: true, orderDetailItem: item });
    console.log(item)
  }
  renderItem(item) {
    return (
      <table key={item.ID} className="my-order-list-item">
        <thead>
          <tr>
            <th colSpan="4">
              <div>
                <p className="p1">
                  <span>订单编号:</span>
                  <span>{item.OrderNo}</span>
                  <span>{moment(new Date(item.PayTime)).format("YYYY-MM-DD HH:mm")}</span>
                </p>
                <div className='order_detail_btn'><p style={{ color: '#666', fontSize: 12, marginRight: 30, cursor: 'pointer' }} onClick={this.onOrderDetail.bind(this, item)}>订单详情<MyIcon type="iconwangyou-" /></p>
                  {
                    item.PayStatus !== 1 && <p className="p2">
                      <Popconfirm placement="top" title={"确认删除订单吗？"} onConfirm={() => this.deleteOrder(item.ID)} okText="确认" cancelText="取消">
                        <MyIcon type="iconshanchu1" />
                      </Popconfirm>
                    </p>
                  }</div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {
            [...item.OrderDetailList, ...item.OrderDetailListPack, ...item.OrderDetailListStage].map((ele, i) => {
              return (
                <tr key={ele.ID}>
                  <td>
                    <div>
                      <img src={ele.CoverPath ? ele.CoverPath + '?x-oss-process=image/resize,m_fixed,h_90,w_160' : IMG_DEFAULT} alt="" />
                      <h1>
                        <p>{ele.Name}</p>
                        <p>授课老师：{ele.teachName || '匿名'}</p>
                      </h1>
                    </div>
                  </td>
                  <td>
                    ¥{(ele.PreferentialPrice).toFixed(2)}
                    {/* {item.UsedPrice > 0 ? <div style={{ fontSize: 12 }}>优惠金额：￥{(item.UsedPrice).toFixed(2)}</div> : ''} */}
                  </td>
                  {this.IsCollapse(item, ele, i)}
                  {this.IsCollapseBtn(item, ele, i)}
                </tr>
              )
            })
          }
        </tbody>
      </table>
    )
  }

  render() {
    let { fetchGetMyOrderSuccess, fetchGetMyOrderTotal, fetchGetMyOrderPending } = this.props.center;
    const { visible, SuccessVisible, refundItem, orderDetailItem, refundTxt, orderDetailOpened } = this.state;
    const orderModalTitle = (item) => {
      return <div style={{ lineHeight: 1 }}>订单编号：{item.OrderNo} <span style={{ marginLeft: 30, color: '#999' }}>{moment(new Date(item.PayTime)).format("YYYY-MM-DD HH:mm")}</span></div>
    }
    return (
      <div className="center-my-order-pane">
        {
          fetchGetMyOrderSuccess && fetchGetMyOrderSuccess.length > 0 ?
            <div className="my-order-list">
              <List
                itemLayout="horizontal"
                size="large"
                pagination={{
                  onChange: page => {
                    this.setState({
                      curPage: page,
                    }, () => {
                      this.onLoadMyOrder();
                    })
                  },
                  current: this.state.curPage,
                  total: fetchGetMyOrderTotal,
                  pageSize: 5,
                }}
                loading={fetchGetMyOrderPending}
                dataSource={fetchGetMyOrderSuccess}
                renderItem={item => this.renderItem(item)}
              />
            </div>
            :
            <div className="noneData">
              <NoneData type={2} />
            </div>
        }
        {
          refundItem && <Modal
            centered
            wrapClassName="refundModal"
            maskClosable={false}
            footer={null}
            width={740}
            visible={visible}
            onCancel={() => this.setState({
              visible: false,
            })}
          >
            <div className="modal-inner">
              <h2>
                申请退款
            </h2>
              <div className="content">
                <div className="item">
                  <img src={refundItem.CoverPath || IMG_DEFAULT} alt="" />
                  <h3>
                    <p className="p1">{refundItem.Name}</p>
                    <p className="p2">授课老师:&nbsp;&nbsp;{refundItem.teachName || "匿名"}</p>
                    <p className="p3">¥{refundItem.PreferentialPrice.toFixed(2)}</p>
                  </h3>
                </div>
                <TextArea
                  value={refundTxt}
                  placeholder="请输入退款原因"
                  className="txtarea"
                  onChange={e => {
                    this.setState({
                      refundTxt: e.target.value
                    })
                  }}
                />
                <div className="btns">
                  <Button onClick={() => this.setState({
                    visible: false
                  })}>取消</Button>
                  <Button type="theme" onClick={this.refundSubmit.bind(this)}>提交</Button>
                </div>
              </div>
            </div>
          </Modal>
        }
        {
          refundItem && <Modal
            centered
            wrapClassName="refundSubSuccess"
            maskClosable={false}
            footer={null}
            width={400}
            visible={SuccessVisible}
            onCancel={() => this.setState({
              SuccessVisible: false,
            })}
          >
            <div className="modal-inner">
              <MyIcon type="icongouxuan" className="success-icon" />
              <p className="p1">提交成功</p>
              <p className="p2">{refundItem.Name}</p>
              <p className="p3">申请退款提交成功,请等待客服为您处理</p>
            </div>
          </Modal>
        }
        {orderDetailItem && <Modal
          title={orderModalTitle(orderDetailItem)}
          wrapClassName="orderDetailWrapClass"
          maskClosable={false}
          footer={null}
          width={1000}
          visible={orderDetailOpened}
          onCancel={() => this.setState({ orderDetailOpened: false })}
        >
          <div className='order_detail_container'>
            {
              [...orderDetailItem.OrderDetailList, ...orderDetailItem.OrderDetailListPack, ...orderDetailItem.OrderDetailListStage].map(item =>
                <div className='order_detail_item' key={item.ID}>
                  <div className='detail_item_image'>
                    <img src={item.CoverPath ? item.CoverPath + '?x-oss-process=image/resize,m_fixed,h_90,w_160' : IMG_DEFAULT} alt="" />
                    {item.BusType === 1 && <div className='detail_item_course_pack_icon'>课程包</div>}
                  </div>
                  <div className='detail_item_main'>
                    <div className='item_main_title'>{item.Name}</div>
                    <div className='item_main_teacher_name'>授课老师：{item.teachName}</div>
                  </div>
                  <div className='detaim_item_price'>￥{item.PreferentialPrice.toFixed(2)}</div>
                </div>
              )
            }

          </div>
          <div className='order_detail_footer'>
            <div className='item_commodity'>共{[...orderDetailItem.OrderDetailList, ...orderDetailItem.OrderDetailListPack, ...orderDetailItem.OrderDetailListStage].length}件商品</div>
            <div className='item_total_price'>总金额：￥{orderDetailItem.Price.toFixed(2)}</div>
            {orderDetailItem.UsedPrice > 0 && <div className='item_coupon_price'>{orderDetailItem.Title}抵扣：-￥{orderDetailItem.UsedPrice.toFixed(2)}</div>}
            <div className='item_payable'>应付：<span className='payable_price'>￥{(orderDetailItem.Price - orderDetailItem.UsedPrice).toFixed(2)}</span></div>
          </div>
        </Modal>
        }
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    center: state.center,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyOrderPane);



// WEBPACK FOOTER //
// ./src/features/center/MyOrderPane.js